import React, { useEffect, useContext } from 'react';
import ComingSoon from './common/ComingSoon';
import Context from '../context/Context';

const Help = () => {
  const { setPageTitle } = useContext(Context);

  useEffect(() => {
    setPageTitle('Help');
  }, [setPageTitle]);

  return (
    <ComingSoon />
  );
};

export default Help;
